const Icon = ({ color }) => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='40' height='40' rx='20' fill={color} fillOpacity='.08' />
    <path
      d='m26.63 10.64-.72.2-5.77 1.65-.7.21.14.51-5.42-1.57-.72-.2-.21.72-2.11 7.17a5.45 5.45 0 0 0-.12 2.98c.24.83.83 1.63 1.76 2.1l-.68 2.47-2.16-.63-.42 1.45 5.77 1.66.42-1.45-2.16-.63.68-2.44a3.47 3.47 0 0 0 2.6-.87 5.37 5.37 0 0 0 1.5-2.55l1.85-6.19 1.53 5.41v.03c.25.89.7 1.84 1.5 2.55.65.59 1.56.94 2.6.85l.68 2.46-2.16.63.42 1.45 5.77-1.66-.42-1.45-2.16.63-.7-2.46a3.46 3.46 0 0 0 1.76-2.11 5.44 5.44 0 0 0-.1-2.98l-2.04-7.22-.2-.72Zm-1 1.85.93 3.35h-4.68l-.6-2.11 4.34-1.24Zm-11.16.82 4.31 1.22-.6 2.06h-4.7l.99-3.28Zm7.83 4.03h4.68l.47 1.66c.2.7.28 1.53.1 2.16-.18.63-.52 1.07-1.43 1.34-.91.26-1.44.06-1.92-.38a4.2 4.2 0 0 1-1.08-1.87l-.82-2.91Zm-9.26.75h4.69l-.85 2.9h-.02c-.2.7-.57 1.44-1.06 1.88-.48.44-1 .64-1.92.38-.9-.27-1.25-.71-1.43-1.34a4.2 4.2 0 0 1 .1-2.16l.49-1.66Z'
      fill={color}
    />
  </svg>
)

export default Icon
